<template>
    <div>
        <popup-camera v-bind:is-active="cameraPopup" v-on:closepopup="closeCameraPopup" v-model="cameraPhotosShore" :max-photos="cameraMaxPhotos"></popup-camera>
        <div v-if="step==1">
            <div class="form-field">
                <p class="form-text">Введите номер страхового случая</p>
                <imasked-input v-model="reqNom" :key="'reqNom'" @change="checkReqNom" :idname="'reqNom'" :invalid="reqNomInvalid" :addclass="reqNomClass" :mask="reqNomMask"></imasked-input>
            </div>
            <p class="form-err-msg" v-if="formErrors">
                Проверьте правильность ввода номера страхового случая.
            </p>
            <button type="button" class="btn main-button next" @click="nextStepOne">ДАЛЕЕ</button>
        </div>
        <div v-if="step==2">
            <div class="form-field">
                <p class="form-text">Сделайте фото досылаемых документов (максимум 8 фото)</p>
                <div class="preview-container">
                    <div class="photos-preview-container" v-for="photo, n in addingPhotos">
                        <img :src="photo" photo class="photo-preview"  />
                        <img src="/images/remove.svg" class="photo-preview-remove" @click="rmPreview(n)">
                    </div>
                </div>

                <div class="file-input-wrapper" v-if="showButtons_addingPhotos">
                    <div class="photo-button photo-button-left" @click="openCamera('addingPhotos', 8)" v-if="mobileBrowser && cameraAvailable">
                        <img src="/images/camera.png">
                        <p>Сделать на камеру</p>
                    </div>
                        <label for="file-add-docs" class="photo-button" v-bind:class="cameraAvailable ? 'photo-button-right': 'pc-photo-btn'">
                            <img src="/images/gallery.png">
                            <p v-if="cameraAvailable">Выбрать из галереи</p>
                            <p v-else>Сделать фото</p>
                        </label>
                        <input id="file-add-docs" @change="onAddingPhotos" type="file" accept="image/*" multiple />
                </div>

                <p class="form-err-msg" v-if="addingPhotosLimErr">
                    {{addingPhotosLimErr}}
                </p>
            </div>
            <div class="form-field">
                <p class="form-text">Ваш комментарий к этим документам (не обязательно)</p>
                <textarea style="height: 200px;" v-model="comment" class="form-input textarea-input" id="comment"></textarea>
            </div>
            <p class="form-err-msg" v-if="formErrors">
                Вы не добавили ни одной фотографии.
            </p>
            <button type="button" class="btn main-button" @click="sendDocs">Дослать документы</button>
        </div>
        <div v-if="step==3">
            <div class="form-field">
                <load-spinner></load-spinner>
            </div>
            <div class="form-field">
                <p class="status-description">Отправляем приложенные документы</p>
            </div>
            <!-- <div class="clock" v-if="!photosUploadError"></div> -->
        </div>
        <div v-if="step==4">

            <div v-if="docsReceived">
                <div class="form-field">
                    <img class="finish-state" src="/images/done.png">
                </div>
                <div class="form-field">
                    <h3>Документы успешно приняты</h3>
                </div>
            </div>
            <div v-if="!docsReceived">
                <div class="form-field">
                    <img class="finish-state" src="/images/alert.png">
                </div>
                <div class="form-field">
                    <h3>Что-то не так</h3>
                </div>
                <div class="form-field">
                    <p class="status-description ">При отправке документов возникла ошибка. Попробуйте снова.</p>
                </div>
                    <!-- <button type="button" class="btn main-button last-steps-btns" @click="finNewCase" v-if="showRetBtn">Повторить отправку</button> -->
            </div>
            <button type="button" class="btn main-button last-steps-btns" @click="goToMain">Вернуться на главный экран</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ImaskedInput from './ImaskInput.vue'
import LoadSpinner from "./LoadSpinner.vue"
import CameraPopup from './CameraPopup.vue'

export default {
    name: 'add-docs',
    props: ['isActive', 'cameraAvailable'],
    components: {
        'imasked-input': ImaskedInput,
        'load-spinner': LoadSpinner,
        'popup-camera': CameraPopup,
    },
	data() {
		return { 
			cameraPopup: false,
			lastVisitedStep: 1,
			step: 1,
			doLiveCheck: false,
			formErrors: false,
			reqNom: "",
			reqNomMask: "0000/000/00000/00",
			reqNomClass: "polis-input",
			reqNomInvalid: false,
			cameraPhotosShore: [],
			cameraPhotosTargetName: "",
			cameraMaxPhotos: 0,
			addingPhotos: [],
            addingPhotosFiles: [],
            showButtons_addingPhotos: true,
			addingPhotosLimErr: "",
			comment: "",
			requestId: "",
			docsReceived: false,
			allPhotosCount: 0,
			uploadedPhotosCount: 0,
			photosUploadError: false,
			getStatusRetrs: 0,
			showRetBtn: true,
			showBtns: true,
		}
	},
	watch: {
		isActive: function(){
			this.clean()
		},
    },
    mounted() {
        let vm = this
        let body = document.getElementById("appbody");
        body.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                vm.enterClicked()
            }
        });
    },
	methods: {
        enterClicked() {
            switch(this.step) {
                case 1:
                    this.nextStepOne()
                    break
                case 2:
                    this.sendDocs()
                    break

            }
        },
		closeCameraPopup() {
			this.cameraPopup = false
            this[this.cameraPhotosTargetName] = this.cameraPhotosShore
            this.controlPhotosBtns(this.cameraPhotosTargetName, this.cameraMaxPhotos)
		},
		openCamera(targetStore, maxPhotos){
			this.cameraPhotosTargetName = targetStore
			this.cameraPhotosShore = this[targetStore]
			this.cameraMaxPhotos = maxPhotos
			this.cameraPopup = true
		},
		prevStep() {
			if (this.step == 1) {
				this.$emit('exitpopup', "Отменить отправку документов?")
				return
			}
			let stepN = this.step - 1
			if (stepN > 0) {
				this.step = stepN
			}
		},
		nextStep() {
			let stepN = this.step + 1
			if (stepN <= this.lastVisitedStep) {
				this.step = stepN
			}
		},
		checkReqNom() {
			if (!this.doLiveCheck) {
				return
			}
			if (this.reqNom.length < 10) {
				this.reqNomInvalid = true
				this.doStepOneErrMsg()
			} else {
				this.reqNomInvalid = false
				this.doStepOneErrMsg()
			}
		},
		onAddingPhotos(e) {
			let files = e.target.files;
			let vm = this
			if(files){
				let photosToAdd = []
				let totalLen = this.addingPhotos.length + files.length
				if (totalLen > 8) {
					let canLeave = 8 - this.addingPhotos.length
					for (let i = 0; i < canLeave; i++) {
						photosToAdd.push(files[i])
					}
					this.addingPhotosLimErr = "Превышено максимальное количество фотографий, сначала удалите фотографии из добавленных. Добавлено фото: " + String(canLeave)
				} else {
					this.addingPhotosLimErr = ""
					photosToAdd = files
				}
				let files_count = photosToAdd.length;
				for (let i=0; i<files_count; i++){
				var reader = new FileReader();
				reader.onload = function(e){
                    vm.addingPhotos.push(e.target.result)
                    vm.controlPhotosBtns('addingPhotos', 8)
					
				}
				this.addingPhotosFiles.push(photosToAdd[i])
				reader.readAsDataURL(photosToAdd[i]);
				}
			}
			
		},
		rmPreview(num) {
			this.addingPhotos.splice(num, 1)
            this.addingPhotosLimErr = ""
            this.controlPhotosBtns('addingPhotos', 8)
        },
        controlPhotosBtns(targetStore, maxPhotos) {
            let store = this[targetStore]
            if (store.length >= maxPhotos) {
                this["showButtons_"+targetStore] = false
            } else {
                this["showButtons_"+targetStore] = true
            }
        },
		checkAddingPhotos() {
			if (!this.doLiveCheck) {
				return
			}
			this.formErrors = false
			if (this.addingPhotos.length == 0) {
				this.formErrors = true
			}
		},
		doStepOneErrMsg() {
			this.formErrors = false
			if (this.reqNomInvalid) {
				this.formErrors = true
			}
		},
		nextStepOne() {
			this.formErrors = false
			this.doLiveCheck = true
			this.checkReqNom()
			if (!this.formErrors) {
				this.step = 2
				this.formErrors = false
				this.doLiveCheck = false
			}
		},
		sendDocs() {
			this.formErrors = false
			this.doLiveCheck = true
			this.checkAddingPhotos()
			if (!this.formErrors) {
				this.step = 3
				this.formErrors = false
				this.doLiveCheck = false
				//Sending data to server
				let formData = new FormData();
				formData.append("reqNom", this.reqNom)
				formData.append("comment", this.comment)
				this.allPhotosCount = this.addingPhotos.length
				formData.append("addingPhotosFilesL", this.addingPhotos.length)
				this.showBtns = false

				let vm = this
				axios.post( '/api/add/documents',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then(function(data){
					vm.requestId = data.data.data
					vm.uploadPhotos()
				})
				.catch(function(){
					vm.step = 4
					vm.docsReceived = false
				});

			}
		},
		uploadPhotos() {
			if (this.addingPhotos.length < 5) {
				let formData = new FormData();
				var uploadPhotosCount = this.addingPhotos.length
				this.addingPhotos.forEach(function (photo, i) {
					formData.append("photo_"+i, photo)
				})
				let vm = this
				axios.post( '/api/add/documents/photos/'+this.requestId,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then(function(data){
					vm.uploadedPhotosCount += uploadPhotosCount
					vm.photosUploadError = false
					vm.photosUploaded()
				})
				.catch(function(){
					vm.photosUploadError = true
				});
			} else {
				let vm = this
				this.addingPhotos.forEach(function (photo, i) {
					let formData = new FormData();
					formData.append("photo_"+i, photo)
					axios.post( '/api/add/documents/photos/'+vm.requestId,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
					).then(function(data){
						vm.uploadedPhotosCount += 1
						vm.photosUploadError = false
						vm.checkIfAllPhotosUploaded()
					})
					.catch(function(){
						vm.photosUploadError = true
						checkIfAllPhotosUploaded()
					});
				})
			}
		},
		photosSendRetry() {
			this.uploadPhotos()
		},
		checkIfAllPhotosUploaded() {
			if (this.uploadedPhotosCount > 1) {
				this.photosUploaded()
			}
		},
		photosUploaded() {
			let vm = this
			axios.get( '/api/add/documents/check/'+this.requestId)
				.then(function(data){
					if (data.data == "OK") {
						vm.step = 4
						vm.docsReceived = true
					} else {
						vm.step = 4
						vm.docsReceived = false
					}
				})
				.catch(function(){
					vm.getStatusRetrs += 1
					if (vm.getStatusRetrs <= 300) {
						vm.photosUploaded()
					} else {
						vm.step = 4
						vm.docsReceived = false
						vm.showRetBtn = false
					}
				});
		},
		clean() {
			this.step = 1
			this.lastVisitedStep = 1,
			this.doLiveCheck = false
			this.formErrors = false
			this.reqNom = ""
			this.reqNomInvalid = false
			this.cameraPhotosShore = []
			this.cameraPhotosTargetName = ""
			this.cameraMaxPhotos = 0
			this.addingPhotos = []
			this.addingPhotosLimErr = ""
			this.comment = ""
			this.docsReceived = false
			this.getStatusRetrs = 0
			this.showRetBtn = true
			this.showBtns = true
		},
		goToMain(){
			// this.clean()
			document.location.replace('/');
		}
	}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/AddDocuments.vue